import React from 'react';

import { FlexContainer, Title } from '../common/StyledComponents';
import placeholderImg from '../../assets/coffee.jpg';
import ContactForm from '../common/Forms/ContactForm';

const backgroundUrl = `url(${placeholderImg})`;

const ContactUs = () => {
  window.scrollTo(0, 0);

  return (
    <div className="w-100">
      <FlexContainer
        className="vh-75 vh-50-ns justify-center items-center bg-center cover"
        background={backgroundUrl}
      >
        <FlexContainer className="flex-column" maxwidth="950px">
          <Title
            // className="pa3 pa4-m pa5-l"
            className="pa3 pa4-ns"
            fontFamily="Montserrat"
            fontWeight="bold"
            fontstyle="italic"
            fontSize="3rem"
            color="#fff"
          >
            Have any queries? We’re always here to help!
          </Title>
          <Title
            className="pa3 pa4-ns"
            fontFamily="Montserrat"
            fontWeight="bold"
            fontSize="1.875rem"
            lineHeight="1.25"
            color="#4db2ec"
          >
            Write us at contact@beebom.com.
          </Title>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer className="justify-center" background="#f3f4f6">
        <FlexContainer
          className="w-100 flex-row-ns flex-column"
          maxwidth="950px"
        >
          <FlexContainer className="contact-form ph3 w-100 mv5-ns mv3 flex-column">
            <Title
              className="mb4"
              fontFamily="Montserrat"
              fontSize="1.25rem"
              fontWeight="bold"
            >
              Leave a Message
            </Title>
            <ContactForm />
          </FlexContainer>
          {/* <FlexContainer className="address ph3 w-50-ns w-100 mv5-ns mb3 flex-column">
            <Title fontFamily="Montserrat" fontSize="1.25rem" fontWeight="bold">
              Visit Our Headquarters
            </Title>

            <Title fontFamily="Montserrat" fontSize="0.875rem" color="#585858">
              <b>Beebom Media Private Media Ltd.</b>
              <br />
              E-43/1, Second-Floor,
              <br />
              Okhla Phase II, Okhla Industrial Area,
              <br />
              New Delhi, Delhi-110020
            </Title>
          </FlexContainer> */}
        </FlexContainer>
      </FlexContainer>

      {/* <FlexContainer
        className="w-100"
        style={{ height: '5px', background: '#4db2ec' }}
      /> */}
    </div>
  );
};

export default ContactUs;
